import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    details: null,
    students: []
};

export const guardianSlice = createSlice({
    name: 'guardian',
    initialState,
    reducers: {
        updateGuardian: (state, action) => {
            state.details = action.payload.details ? action.payload.details : state.details;
            state.students = action.payload.students ? action.payload.students : state.students;
        },
        updateGuardianDetails: (state, action) => {
            state.details = action.payload;
        },
        updateStudents: (state, action) => {
            state.students = action.payload;
        },
        clearGuardian: (state) => {
            state.details = null;
            state.students = [];
        }
    }
});

export const { updateGuardian, updateGuardianDetails, updateStudents, clearGuardian } = guardianSlice.actions;

export default guardianSlice.reducer;
